import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Layouts
import DashboardLayout from '../../layouts/DashboardLayout'
// Components
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
// ant
// Mobx
import { inject, observer } from 'mobx-react'
import MissionCreateForm from './MissionCreateForm'
import { systemName } from '../../config'
import AppPageHeader from '../../components/AppPageHeader'

const MissionCreatePage = props => {
  const { history, selectPeopleStore } = props

  useEffect(() => {
    return () => {
      selectPeopleStore.clearSelected()
    }
  }, [])

  const handleAfterCreatedMission = () => {
    history.push('/mission')
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>Tạo mới nhiệm vụ | {systemName} tạo mới nhiệm vụ</title>
      </Helmet>
      <PageTitle location={props.location} hiddenGoBack />
      <ContentBlockWrapper>
        <AppPageHeader title="Tạo mới nhiệm vụ" />
        <MissionCreateForm
          handleAfterCreatedMission={handleAfterCreatedMission}
        />
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

export default inject('selectPeopleStore')(observer(MissionCreatePage))
